import { useEffect, useState } from 'react'
import {
  AdminToolWrapperProps,
  ErrorType,
  LoadingWrapper,
  WrapperProps
} from '.'
import {
  ErrorProvider,
  TranslationProvider,
  useErrorHandling
} from '../contexts'
import baseData from '../translations.json'
import { byValue, extend } from '../utils/configHelpers'
import { IntlProviderWrapperNew } from './localization'
import { CustomTranslationsWrapper } from './custom-translations-wrapper'
import { TRANSLATIONS_ERROR } from './errors/constants'
import { fetchData, TranslationsMap } from '../utils'

const IntlProviderWrapper = ({ children }: WrapperProps) => {
  const [data, setData] = useState<TranslationsMap | undefined>(undefined)

  const { setErrorData } = useErrorHandling()

  useEffect(() => {
    const fetchTranslations = async () => {
      const fetchDataFromJsonFile = async (url: string) => {
        return fetchData(url, {
          cache: 'no-store'
        })
      }

      try {
        const clientTranslationsData = await fetchDataFromJsonFile(
          '/translations/translations.json'
        )

        const commonTranslationsData = byValue(baseData)

        setData(extend(commonTranslationsData, clientTranslationsData, true))
      } catch (e) {
        setErrorData({
          error: new Error(TRANSLATIONS_ERROR),
          errorType: ErrorType.FETCH_TRANSLATIONS
        })
      }
    }

    fetchTranslations()
  }, [setErrorData])

  return (
    <LoadingWrapper isLoading={data === undefined}>
      {data && (
        <CustomTranslationsWrapper data={data}>
          {children}
        </CustomTranslationsWrapper>
      )}
    </LoadingWrapper>
  )
}

const IntlWrapper = ({ children, useAdminTool }: AdminToolWrapperProps) => {
  return (
    <TranslationProvider>
      <ErrorProvider useAdminTool={useAdminTool}>
        {useAdminTool ? (
          <IntlProviderWrapperNew>{children}</IntlProviderWrapperNew>
        ) : (
          <IntlProviderWrapper>{children}</IntlProviderWrapper>
        )}
      </ErrorProvider>
    </TranslationProvider>
  )
}

export { IntlWrapper }
